module.exports = __webpack_public_path__ + "img/stadia-ios-homepage-pwa-framed_2x.f3eda600.jpg";